// https://en.wikipedia.org/wiki/ABA_routing_transit_number
export const routingNumberValidator = (value: string): boolean => {
  if (value && value.length === 9) {
    const digits = value.split("").map((d) => parseInt(d, 10));
    const checksum =
      3 * (digits[0] + digits[3] + digits[6]) +
      7 * (digits[1] + digits[4] + digits[7]) +
      (digits[2] + digits[5] + digits[8]);

    return checksum % 10 === 0;
  }

  return false;
};
